import React, { Fragment } from 'react';
import Yup from 'yup';

import Card, { Column } from 'buyside/components/base/Card/Card';
import FlashMessage from 'buyside/components/presentation/FlashMessage/flashMessage';
import MessageForm, {
  UserAutocomplete,
  TextArea,
  SubmitButton,
  SubjectInput,
  AttachmentArea
} from 'buyside/components/presentation/MessageForm/MessageForm';
import { SubjectError, UserError, BodyError } from './NewMessageFormErrors';

import styles from './NewMessageFormStyles';

const customMessageSchema = Yup.object().shape({
  body: Yup.string().required('Message body is required'),
  subject: Yup.string().required('Subject is required'),
  receiverUserId: Yup.string().required('Receiver is required')
});

const initialValues = {
  receiverUserId: ''
};

const FormLabel = ({ children }) => <span className={styles.formLabel}>{children}</span>;

class NewMessageForm extends React.Component {
  constructor() {
    super();
    this.state = {
      error: null
    };
    this.handleError = this.handleError.bind(this);
  }

  handleError(error) {
    this.setState({ error: error['graphQLErrors'][0]['message'] });
  }

  render() {
    const { createMessage, afterSubmit, toUserId = undefined, userInfo = undefined } = this.props;
    if (toUserId) {
      initialValues.receiverUserId = toUserId;
    }
    const directMessageInputProps = {};
    if (userInfo) {
      directMessageInputProps.value = userInfo;
      directMessageInputProps.disabled = true;
    }

    return (
      <MessageForm
        messageSchema={customMessageSchema}
        createMessage={createMessage}
        afterSubmit={afterSubmit}
        handleError={this.handleError}
        initialValues={initialValues}
      >
        {this.state.error && (
          <FlashMessage>
            {({ flashMessageStyles }) => (
              <div className={`${flashMessageStyles} ${styles.flashMessage}`}>
                {this.state.error}
              </div>
            )}
          </FlashMessage>
        )}
        <Card>
          {({ cardStyle }) => (
            <div className={`${cardStyle} ${styles.cardContainer}`}>
              <Column>
                <FormLabel>Subject:</FormLabel>
                <SubjectInput />
                <SubjectError />
                <FormLabel>To:</FormLabel>
                <Fragment>
                  <UserAutocomplete inputProps={directMessageInputProps} />
                  <UserError />
                </Fragment>
                <FormLabel>Message:</FormLabel>
                <TextArea />
                <BodyError />
                <AttachmentArea />
                <div className={styles.buttonContainer}>
                  <SubmitButton analyticsTag="submit-message-button" />
                </div>
              </Column>
            </div>
          )}
        </Card>
      </MessageForm>
    );
  }
}

export default NewMessageForm;
